/**
 * Redux enabled view for the password reset requested page
 */
import React, { FunctionComponent } from 'react';
import PurePasswordResetRequested from './password-reset-requested-view';
import { useDispatch } from 'react-redux';
import { checkPasswordResetGranted, infoBoxDismissed } from 'phoenix2/state/new-user/actions';

export const PasswordResetRequestedView: FunctionComponent = () => {
    const dispatch = useDispatch();

    return (
        <PurePasswordResetRequested
            backToLogin={() => dispatch(infoBoxDismissed())}
            checkPasswordResetGranted={() => dispatch(checkPasswordResetGranted())}
        />
    );
};
